import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIcon from "../img/svg/close_blue_new_design.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function PopupWithSmile({
  isOpen,
  setIsOpen,
  headerText,
  subheaderText,
  confirmBtnText,
  cancelBtnText,
  bodyText,
  bodySubText,
  handleSubmit,
  headerTextTop,
  headerTextBottom,
  displayCloseBtn = true,
}) {
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{ p: 0 }}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <Box>
        <Box>
          <DialogTitle
            sx={{
              m: 0,
              p: 2,
              display: "flex",
              justifyContent: displayCloseBtn ? "space-between" : "end",
              gap: "5px",
              alignItems: "baseline",

              textAlign: "center",
            }}
            id="customized-dialog-title"
          >
            {displayCloseBtn && <img src={CloseIcon} alt="close" onClick={handleClose} />}

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <Typography
                gutterBottom
                sx={{
                  fontSize: "24px",
                  m: 0,
                  color: "var(--darkblue)",
                  textAlign: "center",
                  fontFamily: `var(--font-family) !important`,
                  lineHeight: "28px",
                  fontWeight: 700,
                }}
              >
                {headerTextTop}
              </Typography>
              <Typography
                gutterBottom
                sx={{
                  fontSize: "24px",
                  direction: "rtl",
                  m: 0,
                  lineHeight: "28px",
                  color: "var(--darkblue)",
                  textAlign: "center",
                  fontWeight: 700,
                  fontFamily: `var(--font-family) !important`,
                }}
              >
                {headerTextBottom}
              </Typography>
            </Box>
          </DialogTitle>
        </Box>
        <DialogContent
          sx={{
            direction: "rtl",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* <div className="img-container">
            <img src={verificationError} alt="" />
          </div> */}

          <Typography
            gutterBottom
            sx={{
              fontFamily: `var(--font-family) !important`,
              fontSize: "16px",
              m: 0,
              textAlign: "right",
              color: "var(--red-text-color)",
              fontWeight: 900,
            }}
          >
            {subheaderText}
          </Typography>

          <Typography
            gutterBottom
            sx={{
              fontSize: "16px",
              m: 0,
              textAlign: "right",
              color: "#1E1E1E",
              mb: "5px",
              fontFamily: `var(--font-family) !important`,
              fontWeight: 400,
            }}
          >
            {bodyText}
            <Typography
              gutterBottom
              sx={{
                fontSize: "16px",
                m: 0,
                textAlign: "right",
                color: "#1E1E1E",
                mt: "5px",
                fontFamily: `var(--font-family) !important`,
                fontWeight: 400,
              }}
            >
              {bodySubText}
            </Typography>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 0, display: "flex", justifyContent: "revert", m: "0px" }}>
          <Button
            variant="contained"
            className="phone-dialog-btn phone-dialog-red-btn"
            onClick={handleSubmit}
            style={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {confirmBtnText}
          </Button>
          <Button
            style={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
            }}
            variant="contained"
            className="phone-dialog-btn phone-dialog-secondary-btn"
            onClick={handleClose}
          >
            {cancelBtnText}
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
}
